import { fetchData } from '@/core/graphqlClient/queryClient';
import { getMarket, getPlatform } from '@/core/settings/utils';
import {
  DeliveryOfferV2Document,
  type DeliveryOfferV2Query,
  type DeliveryOfferV2QueryVariables,
} from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/services/graphql/deliveryOfferV2/generated/deliveryOfferV2.query.generated';
import type {
  DeliveryOffer,
  DeliveryQueryParams,
} from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';
import { parseOffetTime } from '@/productDiscovery/ProductPage/common/modules/Delivery/Utils/parseOffetTime';
import { Currency } from '@/productDiscovery/ProductPage/interfaces/Detail.common.model';

export const deliveryOfferV2Gql = (
  queryParams: DeliveryQueryParams,
): Promise<DeliveryOffer[]> =>
  fetchData<DeliveryOfferV2Query, DeliveryOffer[]>(
    DeliveryOfferV2Document,
    {
      platform: getPlatform().toUpperCase(),
      market: getMarket().toUpperCase(),
      isMf: queryParams.isManoFulfillment,
      productId: queryParams.productId,
      sellerId: queryParams.sellerId,
      sku: queryParams.sku,
      quantity: queryParams.quantity,
      amount: queryParams.unitPrice.amount,
      currency: queryParams.unitPrice.currency,
      weight: queryParams.weight * 1000,
    } as DeliveryOfferV2QueryVariables,
    {
      processor: ({ data, ...result }) => ({
        ...result,
        data:
          data?.deliveryOfferV2?.map(
            ({ deliveryCountries, name, mode, estimateDelivery }) => ({
              countries: deliveryCountries,
              name,
              type: mode,
              minDeliveryTime: estimateDelivery.deliveryTime.min,
              maxDeliveryTime: estimateDelivery.deliveryTime.max,
              orderBefore: parseOffetTime(
                estimateDelivery.deliveryTime.orderBefore,
              ),
              deliveryPrice: {
                amount: estimateDelivery.price.amount,
                currency: estimateDelivery.price.currency as Currency,
              },
              isExpress: estimateDelivery.isExpress,
              isBestDeliveryOffer: estimateDelivery.isBestDeliveryOffer,
              expressMode: estimateDelivery.deliveryTime.expressMode,
            }),
          ) ?? [],
      }),
    },
  ).then((res) => res.data ?? []);
